import { Injectable } from '@angular/core';
import { Helper } from '../helpers/helper';
// Usar Jquery
import * as $ from 'jquery';

@Injectable()
export class UploadFilesService {

  constructor(private helper: Helper) { }

  uploadCedula(file: File, cedula: string): Promise<any> {
    return new Promise((res, reject) => {

      const formData = new FormData();

      formData.append('fileKey', file);
      formData.append('cedula', cedula);
      formData.append('tipo', 'cedula');

      $.ajax({
        type: 'POST',
        headers: {
          'Authorization': `Bearer ${ localStorage.getItem('token') || ''}`,
          'compania': this.helper.compania
        },
        url: this.helper.urlServer + '/api/v1/upload-archivo-cliente',
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
        success: (response) => {
          res(response);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/upload-files.service.ts